import {
  NavLink, Outlet, useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import { SideNav } from '@zolteam/zol-admin-ui';
// Permissions
import permissions from '../../permissions/permissionManagement';
import ProtectedFeature from '../../permissions/ProtectedFeature';

/**
 * @typedef {object} UserFormLink
 * @property {string} label
 * @property {string} to
 * @property {Array<string>} permissions
 */

/**
 * The user form component.
 * @returns {React.ReactElement} The user form component.
 */
function UserForm() {
  // Hooks
  const { t } = useTranslation();
  const params = useParams();

  // States and variables
  /** @type {UserFormLink[]} */
  const links = [{
    label: t('parazol.userForm.infoLinkLabel'),
    to: `/user/${params.id}/profile`,
    permissions: permissions.users.updateUserProfile,
  },
  {
    label: t('parazol.userForm.emailLinkLabel'),
    to: `/user/${params.id}/email`,
    permissions: permissions.users.updateUserEmailAddress,
  },
  {
    label: t('parazol.userForm.activateLinkLabel'),
    to: `/user/${params.id}/activate`,
    permissions: permissions.users.activateDeactivateUser,
  }];

  return (
    <SideNav links={links} views={<Outlet />}>
      {(/** @type {UserFormLink} */link) => (
        <ProtectedFeature permissions={link.permissions}>
          <NavLink to={link.to} className={({ isActive }) => (isActive ? 'activeLink' : '')}>
            {link.label}
          </NavLink>
        </ProtectedFeature>
      )}
    </SideNav>
  );
}

export default UserForm;
